/**
 * @module router/journal
 * Journal routes — double-entry GL data entry.
 *
 * Gating note: the GL *entry* page (/accounting/journal) is exposed to the
 * "journal" app so a scoped operator (admin + journal app) can record entries
 * and review the list shown beneath the form. The rest of the GL suite (Ledger,
 * Trial Balance, Financials, COA, Periods) is TEMPORARILY appadmin-only while the
 * full GL is rolled out — so granting "journal" reveals ONLY the Journal page.
 */
const journalRoutes = [
  {
    path: "/accounting/journal",
    name: "Journal",
    component: () => import("@/views/accounting/JournalView.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: "journal" },
  },
  {
    path: "/accounting/ledger",
    name: "Ledger",
    component: () => import("@/views/accounting/LedgerView.vue"),
    meta: { requiresAuth: true, requiresAppAdmin: true },
  },
  {
    path: "/accounting/coa",
    name: "Coa",
    component: () => import("@/views/accounting/CoaView.vue"),
    meta: { requiresAuth: true, requiresAppAdmin: true },
  },
  {
    path: "/accounting/trial-balance",
    name: "TrialBalance",
    component: () => import("@/views/accounting/TrialBalanceView.vue"),
    meta: { requiresAuth: true, requiresAppAdmin: true },
  },
  {
    path: "/accounting/financials",
    name: "Financials",
    component: () => import("@/views/accounting/FinancialsView.vue"),
    meta: { requiresAuth: true, requiresAppAdmin: true },
  },
  {
    path: "/accounting/periods",
    name: "Periods",
    component: () => import("@/views/accounting/PeriodsView.vue"),
    meta: { requiresAuth: true, requiresAppAdmin: true },
  },
];

export default journalRoutes;
